import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import utils from 'utils';
import actions from 'state/actions';

import Header from 'components/Modal/Header';
import selectors from 'state/selectors';
import services from 'services';
import { useAsync } from 'react-use';
import { Dropdown } from 'components/Input';
import Modal from 'components/Modal';

const CustomTitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: bold;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
`;

const AddOrReplaceMassiveUser = () => {
  const dispatch = useDispatch();

  const t = utils.intl.useTranslator();
  const { type } = useSelector(selectors.modal.getModalProps) || {
    type: 'add',
  };
  const [listOfUserGroup, setListOfUserGroup] = useState<Array<{ idUser: number; username: string }>>([]);
  const [replacerUser, setReplacerUser] = useState<{
    value: number;
    label: string;
  } | null>(null);
  const selectedCompanyDefinition = useSelector(selectors.configurator.getSelectedCompanyDefinition);
  // GROUPUSER
  const oUserSelected = useSelector(selectors.configurator.getSelectedOUser);
  const { revalidate } = services.useGetCompanyGroups('getCompanyGroupsKey', selectedCompanyDefinition?.idCompany);
  useAsync(async () => {
    if (!selectedCompanyDefinition?.idCompany) return;
    const { data } = await services.getUsersForGroup(selectedCompanyDefinition.idCompany);
    setListOfUserGroup(data);
  }, [selectedCompanyDefinition?.idCompany]);

  const clearState = () => {
    setListOfUserGroup([]);
    dispatch(actions.configurator.setSelectedGroupFromCompanySelected(null));
    dispatch(actions.configurator.setSelectedOUserList(null));
  };

  const onAction = async () => {
    try {
      if (!oUserSelected?.idUser || !replacerUser?.value) return;

      const serviceAction = type === 'add' ? services.addUserMassivelyWfGroup : services.replaceUserMassivelyWfGroup;

      await serviceAction(oUserSelected?.idUser, replacerUser?.value);
      clearState();
      await revalidate();

      utils.app.notify('success', t(type === 'add' ? 'add-massive-success' : 'replace-massive-success'));
      dispatch(actions.modal.closeModal());
    } catch (error) {
      console.error('Error', error);
      await revalidate();
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <Container>
      <Header title={type === 'add' ? t('add-massive-user') : t('replace-massive-user')} />
      <Container>
        <CustomTitle>{t('selected-user')}</CustomTitle>
        <Dropdown
          id="selected-user-dropdown"
          options={listOfUserGroup.map((user) => {
            return {
              value: user.idUser,
              label: user.username,
            };
          })}
          value={{
            value: oUserSelected?.idUser,
            label: oUserSelected?.username,
          }}
          disabled
        />
      </Container>
      <Container>
        <CustomTitle>{t('replacer-user')}</CustomTitle>
        <Dropdown
          id="replacer-user-dropdown"
          options={listOfUserGroup
            .map((user) => {
              return {
                value: user.idUser,
                label: user.username,
              };
            })
            .filter((user) => user.value !== oUserSelected?.idUser)}
          placeholder="Select an option"
          value={replacerUser}
          onChange={(value) => {
            setReplacerUser(value);
          }}
        />
      </Container>
      <Modal.Footer
        confirmAction={onAction}
        confirmText={type === 'add' ? t('add-massive') : t('replace-massive')}
        confirmDisabled={!replacerUser}
        closeButtonText={t('close')}
        cancelAction={() => {
          dispatch(actions.configurator.setListOfUserForGroup([]));
        }}
      />
    </Container>
  );
};

export default AddOrReplaceMassiveUser;
